
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic05Off as ObiHydraulic05OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-05-off.js';
 
 
 

 
 export const ObiHydraulic05Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-05-off',
   elementClass: ObiHydraulic05OffElement,
   events: {
     
   }
  });
 
 